<template>
  <v-col align="center">
    <v-card width="1000">
      <v-card-title>
        <ProductCardHeader :product-id="product.id" />
      </v-card-title>
      <v-card-text style="color: #4F4F4F">
        <div v-if="!isSubscribed">
          <v-row class="pa-3">
            <div style="text-align: start">
              By clicking the CONFIRM button below, I acknowledge that I have read and agree to the terms outlined in the <a href="https://www.hawksoft.com/terms/agreement/" target="_blank">HawkSoft Terms and Conditions</a>, consent to sync my data with HawkSoft, and I understand that this action cannot be undone.
            </div>
          </v-row>
        </div>
        <div v-else>
          <v-row class="pa-3" style="text-align: start">
            Congratulations! Your HawkSoft Data Sync configuration is complete.
          </v-row>
        </div>
      </v-card-text>
      <v-card-actions>
        <v-row v-if="!isSubscribed" class="pa-3" justify="end">
          <v-col class="pa-2">
            <v-btn @click="returnToMarketplace()">Return to Marketplace</v-btn>
          </v-col>
          <v-col class="pa-2">
            <v-btn color="#FF9E15" @click="handleSubscribe()">Confirm</v-btn>
          </v-col>
        </v-row>
        <v-row v-else class="pa-3" justify="end">
          <v-btn color="#FF9E15" @click="returnToMarketplace()">Return to Marketplace</v-btn>
        </v-row>
      </v-card-actions>
    </v-card>
  </v-col>
</template>

<script>
import { mapGetters, mapActions } from 'vuex';
import ProductCardHeader from '@/components/products/shared/ProductCardHeader';
import productIdMappingMixin from '@/mixins/productIdMappingMixin';

export default {
  name: 'HawkSoftCloud',
  components: {
    ProductCardHeader
  },
  mixins: [productIdMappingMixin],
  computed: {
    ...mapGetters(['getProductByProductId']),
    version () {
      return this.getAgencyVersion;
    },
    product () {
      return this.getProductByProductId(this.getProductId('hawkSoftCloud'));
    },
    isSubscribed () {
      var product = this.getProductByProductId(this.getProductId('hawkSoftCloud'));
      if (product) {
        return product.isSubscribed;
      }
      return false;
    }
  },
  methods: {
    ...mapActions(['setProductSubscription', 'setError']),
    returnToMarketplace () {
      this.$router.push('/marketplace');
    },
    async handleSubscribe () {
      const response = await this.$api.enableHawkSoftCloud();
      if (response.code !== 0 && response.code !== 2) {
        this.setError({ errorMessage: `Error - Unable to enable user for HawkSoft Data Sync. Message: ${response.message}` });
        this.$router.push({ path: '/error' });
        return;
      }
      this.setProductSubscription({ productId: 1, subscription: true });
      this.$router.push('/product/hawksoftCloud/success');
    }
  }
};

</script>
